export const isEmpty = (obj) => {
  if (obj === null || obj === undefined) return true;
  if (obj.constructor === Boolean && !obj) return true;
  if (obj.constructor === Number && Number.isNaN(obj)) return true;
  if (obj.constructor === String && obj.replace(/\s/g, '').length === 0) return true;
  if (obj.constructor === Array && obj.length === 0) return true;
  if (obj.constructor === Object) {
    return Object.keys(obj).length === 0;
  }
  return false;
};

export const isInViewport = (elem, options) => {
  const {
    fullVisibility = false,
    offsetX = 0,
    offsetY = 0
  } = options || {};
  let isVisible = false;
  let offLeft = false;
  let offRight = false;
  let offTop = false;
  let offBottom = false;
  let elemTop = 0;
  let elemBottom = 0;
  let elemLeft = 0;
  let elemRight = 0;
  if (!isEmpty(elem)) {
    const rect = elem.getBoundingClientRect();
    elemTop = rect.top + offsetY;
    elemBottom = rect.bottom + offsetY;
    elemLeft = rect.left + offsetX;
    elemRight = rect.right + offsetX;
    if (fullVisibility) {
      // Only if elem is completely visible
      isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    } else {
      isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    }
    // also return what sides it is off
    offTop = elemTop < 0;
    offLeft = elemLeft < 0;
    offRight = elemRight > (window.innerWidth || document.documentElement.clientWidth);
    offBottom = elemBottom > (window.innerHeight || document.documentElement.clientHeight);
  }
  return {
    isVisible, elemTop, elemBottom, offTop, offBottom, offLeft, offRight
  };
};